import { useState } from "react"
import { createPortal } from "react-dom"
import classNames from "classnames"
import styled from "styled-components"

import { useChangePerformanceTestStatusMutation } from "store/api/performanceTestApi"
import styles from "assets/scss/index.module.scss"
import { ReactComponent as IconRemove } from "assets/svg/modal-icon-remove.svg"

import { ModalLayout } from "layouts/ModalLayout"
import { Spinner } from "components/common/Spinner"
import { ButtonNew } from "components/form/ButtonNew"

const StyledButton = styled(ButtonNew)`
  flex: 1;
  white-space: nowrap;
`
const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 768px) {
    gap: 8px;

    > span {
      padding: 0 8px !important;
    }
  }
`

interface PerfTestStatusChangeModalProps {
  perfTestResultId: number
  onCancel: () => void
}

const PerfTestStatusChangeModal = ({ perfTestResultId, onCancel }: PerfTestStatusChangeModalProps) => {
  const [isFetching, setIsFetching] = useState(false)
  const [isRemoving, setIsRemoving] = useState(false)
  const [changePerformanceTestStatus] = useChangePerformanceTestStatusMutation()

  const onChangeStatus = async (e: React.FormEvent<HTMLElement>) => {
    e.stopPropagation()
    setIsFetching(true)
    await changePerformanceTestStatus({
      id: perfTestResultId,
      status: "Passed",
    })
    setIsFetching(false)
    onCancel()
  }

  const onRemoveStatus = async (e: React.FormEvent<HTMLElement>) => {
    e.stopPropagation()
    setIsRemoving(true)
    await changePerformanceTestStatus({
      id: perfTestResultId,
      status: null,
    })
    setIsRemoving(false)
    onCancel()
  }

  const handleCancel = (e: React.FormEvent<HTMLElement>) => {
    e.stopPropagation()
    onCancel()
  }

  const renderCustomButtons = () => {
    return (
      <ButtonsContainer>
        <StyledButton onClick={handleCancel} color="greyBordered">
          Cancel
        </StyledButton>
        <StyledButton onClick={onChangeStatus} disabled={isFetching} color={"green"}>
          {isFetching ? <Spinner /> : "Change Status"}
        </StyledButton>
        <StyledButton onClick={onRemoveStatus} color="red" disabled={isRemoving}>
          {isRemoving ? <Spinner /> : "Remove Status"}
        </StyledButton>
      </ButtonsContainer>
    )
  }

  return (
    <>
      {createPortal(
        <ModalLayout width="450px" isFetching={isFetching} customButtons={renderCustomButtons()} onClose={onCancel}>
          <div className={classNames(styles.modalContent, styles.center)}>
            <IconRemove />
            <h3 className={styles.modalTitle}>Change or Remove the status</h3>
            <div className={styles.modalMessage}>
              Do you want to change the status from “Issue” to “Passed” or do you want to remove the Issue status for
              this device?
            </div>
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}

export default PerfTestStatusChangeModal
